module.exports = {
    label: {
        registertitle: "S'enregistrer pour un essai gratuit de ChurchTools",
        churchname: 'Nom de votre église/ministère',
        city: 'Ville',
        countrycode: 'Pays',
        instancename: {
            short: 'Adresse de votre site',
            long: 'Adresse de votre site'
        },
        yoururl: 'URL de votre Churchtools: ',
        baselanguage: {
            short: 'Langue',
            long:
                'La langue dans laquelle votre système sera installé. Par la suite vos utilisateurs peuvent choisir parmis un large choix de langues.'
        },
        contactperson: 'A propos de vous',
        contactpersonDenomination: "Coordonnées de l'administrateur",
        churchinformation: 'A propos de votre église',
        churchinformationDenomination: "Informations sur l'église",
        optionalInformation: 'Information complémentaires',
        name: 'Nom',
        firstname: 'Prénom',
        lastname: 'Nom de famille',
        email: 'Email',
        phone: 'Téléphone en cas de questions',
        discountcode: 'Code de réduction',
        comments: 'Autres commentaires',
        checkagbs: "J'ai lu les {link} ci-joint et je les accepte.",
        checkgdpr: 'J’ai lu la {link}.',
        checknewsletter:
            "Je souhaite recevoir la newsletter mensuelle de ChurchTools avec des conseils et des nouvelles. Je suis conscient(e) que je peux révoquer mon consentement à tout moment avec effet pour l'avenir. Remarque : un lien de désabonnement correspondant se trouve dans chaque newsletter.",
        checknewsletterDenomination:
            'L’administrateur devrait recevoir la newsletter mensuelle avec des conseils et des nouvelles de ChurchTools.',
        agbs: 'Termes & Conditions',
        gdpr: 'informations sur la protection des données',
        website: 'Site Internet ou Facebook',
        currentWebsite: 'Site web actuel ou site Facebook',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        login: 'Connexion Assistance',
        setupService: "Service d'installation",
        setupMeeting: 'Sélection des dates',
        useSetupService: "Utiliser le service d'installation gratuit",
        pleaseSelectDate: 'Veuillez choisir une date:',
        with: 'avec',
        churchtoolsWebsite: 'ChurchTools Website',
        registerWebsite: 'Testez ChurchTools Website gratuitement',
        alreadyCustomer: 'Votre église utilise déjà ChurchTools?',
        notYetCustomer: "Votre église n'est pas encore cliente de ChurchTools?",
        niceHeader: "C'est bien que vous souhaitiez essayer ChurchTools !",
        problemHeader: "Quelle préoccupation ou quel problème aimeriez-vous résoudre avec l'aide de ChurchTools ?",
        problemDescription:
            "Répondez à cette question de la manière la plus précise possible (250 caractères maximum). Cela vous aidera à vous concentrer encore plus sur ce que vous voulez réaliser dans les 30 prochains jours avec l'installation d'essai de ChurchTools.",
        justLooking: '"En fait, je veux juste regarder."',
        justLookingDescription:
            "Dans ce cas, nous vous recommandons notre installation de démonstration, qui est parfaite pour un aperçu rapide des nombreuses fonctions de ChurchTools. Elle est déjà remplie d'échantillons de données afin que vous puissiez tester tous les modules sans effort.",
        justLookingDescription2:
            "Vous disposez de trois jours complets pour explorer la démo. Si ce délai n'est pas suffisant, vous pouvez créer une nouvelle démo à tout moment.",
        andNowAFewDetails: 'Et maintenant, quelques détails ...',
        detailsAboutYourChurch: '... sur votre église',
        detailsAboutYou: '... à propos de vous',
        institutionId: 'Institutions-ID'
    },
    button: {
        register: "C'est parti",
        registering: 'Please wait...',
        login: "S'identifier",
        demo: 'Create Demo'
    },
    link: {
        dataprivacy: 'https://church.tools/en/data-security ',
        impressum: 'https://church.tools/en/impressum',
        agbs: 'https://church.tools/en/agb',
        demo: 'https://ccp.church.tools/demo',
        demoXXX: 'https://www.church.tools/de/churchtools-testen?cta=ccp'
    },
    linklabel: {
        dataprivacy: 'Protection des données',
        impressum: 'Mentions légales'
    },
    languages: {
        de: 'Allemand',
        en: 'Anglais',
        pt: 'Portugais'
    },
    language: {
        choose: {
            label: 'Choisissez votre langue:'
        }
    },
    hint: {
        instancename: 'Maximum 30 caractères, seulement a-z, 0-9 et - autorisé',
        appellation: 'Titre',
        discountcode: 'Pour une licence payante future',
        heardfrom: 'Comment avez vous entendu parlé de nous?',
        testChurchTools:
            "Tester gratuitement ChurchTools pendant 30 jours avec toutes ses fonctionnalités. La période d'essai se termine automatiquement, sans qu'il soit nécessaire de résilier le contrat.",
        testChurchToolsPlusWebsite:
            "Tester gratuitement ChurchTools et ChurchTools Website pendant 30 jours avec toutes ses fonctionnalités. La période d'essai se termine automatiquement, sans qu'il soit nécessaire de résilier le contrat.",
        testWebsite: "30 jours d'essai gratuit du système entier",
        setupServiceOptional:
            "Nous vous aidons volontiers à faire vos premiers pas avec ChurchTools et vous soutenons lors de la première installation. Pour cela, nous vous proposons une réunion zoom gratuite d'une heure à laquelle d'autres personnes de votre église peuvent également participer. Lors de cette réunion, nous effectuerons ensemble les premiers réglages de votre nouvelle installation ChurchTools afin que vous puissiez ensuite continuer à tester de manière optimale.",
        setupServiceMandatory:
            "Nous vous aidons à faire vos premiers pas avec ChurchTools et vous soutenons dans la configuration initiale. Pour cela, nous organisons avec vous une réunion zoom gratuite d'une heure, à laquelle d'autres personnes de votre église peuvent également participer. Lors de cette réunion, nous effectuerons ensemble les premiers réglages de votre nouvelle installation ChurchTools afin que vous puissiez ensuite continuer à tester de manière optimale.",
        churchtoolsWebsite:
            'Avec <a href="https://church.tools/website" target="_blank">ChurchTools Website</a> vous pouvez facilement présenter votre église à votre manière individuelle avec des mises en page préfabriquées. Vous pouvez afficher les personnes, les groupes et les dates sur le site web en quelques clics à l\'aide de l\'éditeur et les mettre à jour directement depuis ChurchTools.',
        startTestphaseFromChurchTools:
            'Dans ce cas, la phase de test pour ChurchTools Website doit être lancée directement depuis ChurchTools. Dans le menu "Manage", allez à "Public Relations" et ensuite à "ChurchTools Website".',
        contactSupportForCWBKircheHamburg: '',
        freeCombo:
            'Avec ChurchTools Website, la congrégation de votre église reçoit également un paquet Combo gratuit et permanent de <a href="https://church.tools" target="_blank">ChurchTools</a>.',
        institutionId: ''
    },
    appellation: {
        mrs: 'Mme',
        mr: 'Ms.',
        not_specified: "pas d'indication"
    },
    heardfrom: {
        friend: 'Par un ami ou un collègue',
        church: 'Par une autre église',
        google: 'Moteur de recherche comme Google ou Yahoo',
        facebook: 'Facebook',
        instagram: 'Instagram',
        capterra: 'Capterra',
        magazine: 'Par un magazine',
        conference: 'Par une conference ou une exhibition',
        other: 'Autre'
    },
    buttonorderforfree: 'Demande gratuite',
    requiredfield: '* indique un champ requis',
    email: {
        subject: {
            validation: '[ChurchTools] Confirmez votre enregistrement',
            welcome: 'Bienvenue sur ChurchTools',
            day25: "La période d'essai de ChurchTools se termine dans 5 jours",
            day30: "Votre période d'essai gratuite de ChurchTools se termine aujourd'hui",
            day45: 'Une mauvaise et une bonne nouvelle',
            day80: 'Nous sommes désolé...',
            day90: 'Est-ce un au revoir?',
            duplicate: '[ChurchTools] Installation dupliquée',
            licenseChange: 'Licence ChurchTools modifiée',
            licenseOrderConfirmation: 'Confirmation de votre commande de ChurchTools',
            soondeleteinstance: '[ChurchTools] Votre installation est inactive',
            deleteinstance: '[ChurchTools] Votre installation a été supprimée',
            newlicensemodel: 'Nouvelles importantes de ChurchTools',
            siteCreated: 'Installation de ChurchTools créée'
        },
        logo: 'https://ccp.church.tools/images/ct-logo-slogan-en.png'
    },
    header: {
        greeting: 'Bonjour {appellation} {name}',
        register: "S'enregistrer pour une version gratuite de ChurchTools",
        location: 'Lieu: {location}',
        church: 'Eglise: {church}'
    },
    register: {
        header: 'Obtenir ChurchTools gratuitement pendant 30 jours',
        headerWebsite: 'Testez ChurchTools Website gratuitement',
        headerFinder: 'Enregistrer gratuitement ChurchTools pour le profil Finder',
        headerDenomination: "S'inscrire à ChurchTools pour",
        headerDenominationWebsite: "S'inscrire à ChurchTools Website pour",
        headerDenominationUpdateAdmin: 'Mettre à jour ChurchTools-Admin pour',
        headerinstanceavailable:
            '🎉 Félicitations, cette adresse est encore disponible. Essayer ChurchTools gratuitement pendant 30 jours maintenant',
        finished: {
            description:
                "Pour compléter l'installation, confirmez s'il vous plait votre adresse E-Mail. Nous vous avons envoyé un E-Mail sur {email}. Cliquez sur le lien qui est dans l'E-Mail.",
            descriptionDenomination:
                "L'installation de ChurchTools est maintenant prête. Cela peut prendre quelques minutes.</br></br>Dès que cela sera terminé, nous enverrons un e-mail à</br>{email} (Administrator)</br>und</br>{denominationEmail} ({denominationName}).",
            duplicate:
                "Merci pour votre inscription! Notre équipe d'assistance prendra soin de votre installation et vous a envoyé un E-Mail à {email}",
            header: "Votre demande d'installation Churchtools a été effectuée",
            resend: "Envoyer l'E-Mail à nouveau",
            editEmail: 'Adresse E-Mail correcte',
            resendEmail: {
                success: "L'E-Mail pour confirmer votre dresse E-Mail a été envoyé à nouveau",
                error: "L'E-Mail n'a pas pu être envoyé. Réessayez plus tard."
            },
            saveEmail: 'sauvegarder',
            changeEmail: {
                success:
                    "L'adresse E-Mail a été changé avec succès. Un E-Mail pour confirmer votre adresse E-Mail a été envoyé à nouveau",
                error: "L'adresse E-Mail n'a pas pu être changé."
            },
            status: 'État de la configuration',
            again: 'Enregistrer une autre installation'
        }
    },
    setup: {
        status: {
            header: "Merci d'avoir confirmé votre adresse E-Mail!",
            headerDenomination: "Merci pour l'enregistrement!",
            description:
                "Votre installation ChurchTools va maintenant vous être fournie. Cela va prendre quelques minutes. Un instant s'il vous plait.",
            error:
                "Malheureusement, une erreur s'est produite pendant votre installation. Nous essaierons de réparer cela aussi vite que possible et vous contacterons via votre adresse E-Mail {email}"
        },
        finished: {
            header: "L'installation est terminée",
            description:
                'Vous pouvez maintenant vous connecté avec votre E-Mail {email} et votre mot de passe "admin". Allez sur votre Installation <a href="https://{siteName}.church.tools">{siteName}.church.tools</a>.',
            descriptionWebsite:
                "Vous pouvez maintenant vous connecter avec les données d'accès figurant dans l'e-mail de bienvenue, puis modifier votre mot de passe.",
            login: 'Se connecter'
        }
    },
    validation: {
        wait: "Validation des validationToken {token}, un instant s'il vous plait...",
        email: "Ce champ a besoin d'une adresse E-Mail valide",
        empty: 'Ce champ ne peut pas être vide.',
        exactlength: 'Ce champ doit avoir une longueur de {length}.',
        allowed: 'Ce champ doit contenir une des valeurs souvantes: {allowed}.',
        length: 'Ce champ peut seulement avoir entre {min} et {max} caractères.',
        minlength: 'Ce champ doit avoir au moins {min} caractères',
        maxlength: "Ce champ ne peut supporter qu'un maximum de {max} caractères",
        sitename: {
            invalidchars: 'Le champ contiens des caractères invalides, seulement a-z, 0-9 et - sont autorisés.',
            taken: 'Nous sommes désolé. Ce nom de site est déjà pris.',
            notYetKnown: "Le nom de ce site n'est pas encore connu."
        },
        errorHeader: "Erreur de validation de l'E-Mail.",
        churchname: "Entrez le nom complet de l'église (au moins 5 caractères).",
        duplicateEmail: 'Seul une installation par église est autorisé.'
    },
    error: {
        fielderrors: 'Il y a des erreurs de validation.',
        noresendtoken: 'Pas de resend-token donnés.',
        notoken: 'Pas de token donnés.',
        novalidationtoken: 'Pas de token de validation donné.',
        emailvalidated: "L'E-Mail a déjà été validé.",
        sitenamealreadyprogress: 'Une installation avec le même nom de site est déjà en cours.',
        tokeninvalid: "Le token donné n'est pas valide.",
        licensekeyinvalid: "La clé de licence donnée n'est pas valide.",
        internal:
            "Malheureusement, une erreur s'est produite durant l'installation. Nous essaierons de réparer cela aussi vite que possible et vous contacterons via votre adresse E-Mail {email}"
    },
    countries: {
        '---': '-----',
        AF: 'Afghanistan',
        EG: 'Egypte',
        AX: 'Åland',
        AL: 'Albanie',
        DZ: 'Algerie',
        AS: 'Samoa Américaines',
        VI: 'Îles Vierges des États-Unis',
        AD: 'Andorre',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctique',
        AG: 'Antigua et Barbuda',
        GQ: 'Guinée Equatoriale',
        AR: 'Argentine',
        AM: 'Armenie',
        AW: 'Aruba',
        AC: "Île de l'Ascension",
        AZ: 'Azerbaïdjan',
        ET: 'Ethiopie',
        AU: 'Australie',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbade',
        BE: 'Belgique',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermude',
        BT: 'Bhoutan',
        BO: 'Bolivie',
        BA: 'Bosnie Herzégovine',
        BW: 'Botswana',
        BV: 'Ile Bouvet',
        BR: 'Brésil',
        VG: 'Îles Vierges britanniques',
        IO: "Territoire britannique de l'océan Indien",
        BN: 'Brunei',
        BG: 'Bulgarie',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CL: 'Chili',
        CN: 'Chine',
        CK: 'Îles Cook',
        CR: 'Costa Rica',
        DK: 'Danemark',
        DE: 'Allemagne',
        SH: 'Saint Hélène',
        DG: 'Diego Garcia',
        DM: 'Dominique',
        DO: 'République Dominicaine',
        DJ: 'Djibouti',
        EC: 'Equateur',
        SV: 'Salvador',
        ER: 'Érythrée',
        EE: 'Estonie',
        EU: 'Union Européenne',
        FK: 'Îles Malouines',
        FO: 'Îles Féroé',
        FJ: 'Fidji',
        FI: 'Finlande',
        FR: 'France',
        GF: 'Guyanne Française',
        PF: 'Polynésie Française',
        TF: 'Terres australes et antarctiques françaises',
        GA: 'Gabon',
        GM: 'Gambie',
        GE: 'Géorgie',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenade',
        GR: 'Grèce',
        GL: 'Groenland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernesey',
        GN: 'Guinée',
        GW: 'Guinée-Bissau',
        GY: 'Guyana',
        HT: 'Haïti',
        HM: 'Îles Heard-et-MacDonald',
        HN: 'Honduras',
        HK: 'Hong Kong',
        IN: 'Inde',
        ID: 'Indonésie',
        IQ: 'Irak',
        IR: 'Iran',
        IE: 'Irlande',
        IS: 'Islande',
        IM: 'Île de Man',
        IL: 'Israël',
        IT: 'Italie',
        JM: 'Jamaïque',
        JP: 'Japon',
        YE: 'Yémen',
        JE: 'Jersey',
        JO: 'Jordanie',
        KY: 'Îles Caïmans',
        KH: 'Cambodge',
        CM: 'Cameroun',
        CA: 'Canada',
        IC: 'Îles Canaries',
        CV: 'Cape Vert',
        KZ: 'Kazakhstan',
        QA: 'Quatar',
        KE: 'Kenya',
        KG: 'Kirghizistan',
        KI: 'Kiribati',
        CC: 'Îles Cocos',
        CO: 'Colombie',
        KM: 'Comores',
        CD: 'République démocratique du Congo',
        HR: 'Croatie',
        CU: 'Cuba',
        KW: 'Koweït',
        LA: 'Laos',
        LS: 'Lesotho',
        LV: 'Lettonie',
        LB: 'Liban',
        LR: 'Libéria',
        LY: 'Libye',
        LI: 'Liechtenstein',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaisie',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malte',
        MA: 'Maroc',
        MH: 'Îles Marshall',
        MQ: 'Martinique',
        MR: 'Mauritanie',
        MU: 'Île Maurice',
        YT: 'Mayotte',
        MK: 'Macedoine',
        MX: 'Mexique',
        FM: 'Micronésie',
        MD: 'Moldavie',
        MC: 'Monaco',
        MN: 'Mongolie',
        ME: 'Monténégro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Birmanie',
        NA: 'Namibie',
        NR: 'Nauru',
        NP: 'Népal',
        NC: 'Nouvelle Calédonie',
        NZ: 'Nouvelle Zélande',
        NT: 'Zone neutre Irak-Arabie saoudite',
        NI: 'Nicaragua',
        NL: 'Pays-Bas',
        AN: 'Antilles néerlandaises',
        NE: 'Niger',
        NG: 'Nigéria',
        NU: 'Niue',
        KP: 'Corée du Nord',
        MP: 'Îles Mariannes du Nord',
        NF: 'Île Norfolk',
        NO: 'Norvège',
        OM: 'Oman',
        AT: 'Autriche',
        TL: 'Timor Oriental',
        PK: 'Pakistan',
        PS: 'Territoires Palestiniens',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papouasie Nouvelle Guinée',
        PY: 'Paraguay',
        PE: 'Pérou',
        PH: 'Philippines',
        PN: 'Îles Pitcairn',
        PL: 'Pologne',
        PT: 'Portugal',
        PR: 'Porto Rico',
        CI: "Côte D'ivoire",
        CG: 'Congo',
        RE: 'Réunion',
        RW: 'Rwanda',
        RO: 'Roumanie',
        RU: 'Russie',
        SB: 'Îles Solomon',
        ZM: 'Zambie',
        WS: 'Samoa',
        SM: 'San Marin',
        ST: 'Sao Tomé et Principe',
        SA: 'Arabie Saoudite',
        SE: 'Suède',
        CH: 'Suisse',
        SN: 'Sénégal',
        RS: 'Serbié',
        CS: 'Serbie et Monténégro',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        ZW: 'Zimbabwe',
        SG: 'Singapour',
        SK: 'Slovaquie',
        SI: 'Slovénie',
        SO: 'Somalie',
        SU: 'Union Soviétique',
        ES: 'Espagne',
        LK: 'Sri Lanka',
        KN: 'Saint Kitts et Nevis',
        LC: 'Sainte Lucie',
        PM: 'Saint Pierre et Miquelon',
        VC: 'Saint Vincent et les Grenadines',
        ZA: 'Afrique du Sud',
        SD: 'Soudan',
        GS: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
        KR: 'Corée du Sud',
        SR: 'Suriname',
        SJ: 'Svalbard et Jan Mayen',
        SZ: 'Swaziland',
        SY: 'Syrie',
        TJ: 'Tadjikistan',
        TW: 'Taiwan',
        TZ: 'Tanzanie',
        TH: 'Thaïlande',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinité et Tobago',
        TA: 'Tristan da Cunha',
        TD: 'Tchad',
        CZ: 'République Tchèque',
        TN: 'Tunisie',
        TR: 'Turquie',
        TM: 'Turkménistan',
        TC: 'Îles Turques-et-Caïques',
        TV: 'Tuvalu',
        UG: 'Ouganda',
        UA: 'Ukraine',
        HU: 'Hongrie',
        UY: 'Uruguay',
        UZ: 'Ouzbékistan',
        VU: 'Vanuatu',
        VA: 'Vatican',
        VE: 'Vénézuela',
        AE: 'Emirats Arabes Unis',
        US: 'Etats Unis',
        GB: 'Royaume Unis',
        VN: 'Viêt Nam',
        WF: 'Wallis et Futuna',
        CX: 'Île Christmas',
        BY: 'Biélorussie',
        EH: 'Sahara Occidental',
        CF: 'Centrafrique',
        CY: 'Chypre',
        BQ: 'Bonaire',
        BL: 'Saint-Barthélemy',
        MF: 'Saint Martin',
        XK: 'Kosovo',
        SS: 'Soudan du Sud',
        CW: 'Curaçao',
        SX: 'Saint Martin',
        UM: 'Îles mineures éloignées des États-Unis'
    },
    support: {
        dashboard: {
            tabs: {
                errors: 'Erreurs',
                pendings: 'En attente',
                duplicates: 'Doublons',
                inprogress: 'En cours',
                finished: 'Terminé',
                usage: 'Utilisation'
            },
            searchButton: 'Rechercher',
            instancename: "Nom d'instance"
        },
        table: {
            updated: 'Chargé',
            product: 'Produit',
            sitename: 'Nom du site',
            churchname: "Nom de l'église",
            username: 'Nom de la personne',
            email: 'E-Mail',
            baselanguage: 'Language de base',
            cta: "Appel à l'action",
            status: 'Statut'
        },
        registrationDetails: {
            header: "Information d'inscription",
            contactData: 'Contact',
            churchData: 'Eglise',
            isDuplicate: 'Est dupliqué',
            sendNotice: 'Envoyer une notification',
            noDuplicate: 'Pas de Doublons',
            name: 'Nom:',
            email: 'E-Mail:',
            phone: 'Téléphone:',
            registerLanguage: "Langue d'inscription:",
            churchName: "Nom de l'église:",
            city: 'Ville:',
            country: 'Pays:',
            baseLanguage: 'Langue:',
            instanceName: "Nom d'instance:",
            website: 'Site Internet:',
            furtherInformation: 'Informations complémentaires',
            heardFrom: 'Entendu de:',
            discount: 'Réduction:',
            license: 'Licence:',
            created: 'créé:',
            userAgent: 'Navigateur:',
            logs: 'Logs',
            comment: 'commentaire',
            cta: "Appel à l'action:",
            linkfreescout: 'Trouvé dans FreeScout',
            addcomment: 'Ajouter un commentaire',
            proceedinstallation: "Procéder à l'installation",
            lastupdate: 'Chargé:',
            markdone: 'Marqué comme effectué',
            infomails: "Courriels d'information:",
            newsletter: "Bulletin d'information:"
        },
        usageDetails: {
            header: "Détails d'utilisation",
            usageLicenseData: "Données d'utilisation pertinentes pour la licence",
            persons: 'Personnes',
            services: 'Services',
            resources: 'Resources',
            calendars: 'Calendriers',
            stations: 'Campuses',
            usageDataLast30Days: 'Nouvelles entrées dans les 30 derniers jours',
            persons30: 'Personnes',
            personsActive30Days: 'Persons logged in',
            groups30: 'Groupes',
            csEntries30: 'Attributions de service',
            crEntries30: 'Réservations de ressources',
            calEntries30: 'Entrées du calendrier',
            licenseOverUnder: 'Sur-/Sous-utilisation de la licence',
            overLicensed: 'sur-utilisation de la licence',
            underLicensed: 'sous-utilisation de la licence'
        },
        setupState: {
            duplicate: 'Double',
            possibleduplicate: 'Peut être un double',
            error: 'Erreur',
            pending: 'En attente de validation par E-Mail',
            done: 'Effectué',
            inprogress: 'En cours',
            manuelDone: 'marqué comme effectué'
        },
        registrationOverview: {
            noDataFound: "Pas d'entrées valables"
        },
        duplicates: {
            header: 'Peut être une copie',
            intern: 'INTERNE',
            ccp: 'Portail Client',
            tableColumn: {
                type: 'TYPE',
                churchName: "Nom de l'église",
                email: 'E-Mail',
                phone: 'Téléphone',
                city: 'Ville',
                country: 'Pays',
                website: 'Site internet',
                setupState: 'Setup State'
            }
        },
        login: {
            error: "Le nom d'utilisateur ou le mot de passe est faux."
        }
    },
    license: {
        tax: {
            nStb: 'Montant non imposable.',
            nStbUstID:
                'La TVA pour ce service ou travail est due par le destinataire. Votre numéro de TVA est: {ustid}',
            MwSt: '19% de taxe.'
        },
        discount: {
            discountAmountOnSum: '{amount} de la somme{comment}',
            discountAmountOnPart: '{amount} de {part}{comment}',
            discountPercentOnSum: '{percent}% de la somme{comment}',
            discountPercentOnPart: '{percent}% de {part}{comment}',
            fixPriceForSum: 'Prix total fixe{comment}',
            fixPriceForPart: 'Prix total fixe pour {part}{comment}',
            minPriceForSum: 'Somme du prix total minimal négocié de {price}{comment}',
            minPriceForPart: 'Additionner le prix minimum négocié de {price} for {part}{comment}'
        },
        yes: 'oui',
        no: 'non',
        dateformat: 'JJ/MM/AA',
        unlimited: 'illimité',
        financeClients: 'Clients',
        syncConnections: 'Connexions de synchronisation'
    },
    demo: {
        header: 'ChurchTools Demo',
        information: {
            header: 'Informations sur la démo',
            text:
                "L'installation de démonstration de ChurchTools est remplie d'exemples de données pour vous permettre d'explorer ChurchTools. Cette installation est gratuite et sera automatiquement supprimée après 3 jours."
        },
        support: {
            text: 'Si vous avez des questions, notre équipe de support est à votre disposition.',
            contact: 'Contacter le support'
        },
        create: {
            button: 'Créer une démo',
            spinner: "Nous créons une nouvelle démo pour vous. Cela peut prendre jusqu'à une minute."
        },
        churchtools: {
            button: 'Accéder à ChurchTools',
            text: 'Votre démo a été créée'
        },
        error: {
            header: 'Il y a eu un problème',
            text:
                "Il semble qu'il y a une erreur. Malheureusement, aucune démo de ChurchTools n'a pu être créée. Merci de recharger la page et d'essayer à nouveau. Si le problème persiste, notre équipe d'assistance se fera un plaisir de la régler.",
            reload: 'Recharger'
        },
        template: {
            label: 'Choisir une démo:',
            freikirche: 'Église libre',
            evangelisch: 'Évangélique',
            katholisch: 'Catholique',
            cvjm: 'CVJM'
        }
    }
};
